// extracted by mini-css-extract-plugin
export var loadingSpinner = "_50-1";
export var standaloneTable = "_50-0";